<template>
	<div class="home white">
		<Header :category="category"></Header>
		<div style="max-width:500px;margin:0 auto;" class="py-8">
			<v-card class="px-3 pt-5 pb-3 elevation-0">
				<h3 class="font-weight-bold mb-4 text-nls">
					25분 무료체험하고
					<span class="primary--text">10% 할인쿠폰</span> 받아가세요!
				</h3>
				<!-- <Book /> -->
				<v-btn
					x-large
					depressed
					block
					class="rounded-lg"
					color="primary"
					@click="goTrial"
				>
					무료수업 신청하기
				</v-btn>
			</v-card>
		</div>
		<v-slide-group v-model="slide" show-arrow center-active class="pb-section">
			<v-slide-item v-for="(review, index) in reviews" :key="index">
				<v-card
					outlined
					class="mx-2 mb-1 pa-2 d-flex align-center"
					style="max-width:300px;"
					@click="slide = index"
				>
					<div>
						<v-avatar color="primary" size="50">
							<v-img
								style="border-radius:50%;"
								:src="require(`@/assets/img/reviews/review-${index + 1}.png`)"
							></v-img>
						</v-avatar>
					</div>
					<div class="pl-2">
						<p class="text-body-2 text-nls text-right">
							{{ review.content }}
						</p>
						<div class="mt-2 mb-1">
							<div
								style="width:50px;height:2px;float:right;"
								class="primary"
							></div>
							<div style="clear:both;"></div>
						</div>
						<p class="grey--text text--darken-1 text-caption text-right">
							{{ review.reviewer }}
						</p>
					</div>
				</v-card>
			</v-slide-item>
		</v-slide-group>
		<div class="py-section text-center">
			<h1 class="text-nls text-sm-h3 text-h4 font-weight-bold">
				채팅으로<br class="d-block d-sm-none" />
				영어회화 실력이 느나요?
			</h1>
		</div>
		<section
			class="white--text text-center py-section"
			style="background-color:#35393e;"
		>
			<h2 class="text-nls pb-12 text-h4 font-weight-bold">
				1. 시간 대비 가장 효과적인<br class="d-block d-sm-none" />
				영어회화 학습법
			</h2>
			<p class="text-sm-h6 text-body-1 font-weight-regular text-nls mb-8">
				연구에 따르면, 채팅영어가 말하기 수업보다<br />
				영어회화 실력을 67% 더 빠르게 향상시킵니다.<br />
				<br />
				즉각적으로 반응해야 하는 면대면 의사소통과 달리<br />
				채팅영어는 언어에 대해 계획하고 생각할 시간이 있어<br />
				더 복잡한 문장과 다양한 단어를 구사합니다.
			</p>
			<div class="px-4">
				<v-img
					class="mx-auto mb-8"
					max-width="900"
					:src="
						require(`@/assets/img/b2b/chart${
							userDevice === 'mobile' ? '-mobile' : ''
						}.png`)
					"
				></v-img>
			</div>
			<p class="grey--text text-caption">
				[제 2언어 구사력 향상 목적을 위한 텍스트 기반 인터넷 채팅의 잠재력,
				Christopher blake]<br />
				Potential of Text-Based Internet Chats for Improving Oral Fluency in a
				Second Language, 2009, C. Blake
			</p>
		</section>
		<section class="text-center py-section">
			<h2 class="text-nls pb-12 text-h4 font-weight-bold">
				2. 더 오래 기억에 남는<br class="d-block d-sm-none" />
				원어민 실시간 첨삭
			</h2>
			<p class="text-sm-h6 text-body-1 font-weight-regular text-nls mb-8">
				유창성과 정확성을 동시에 높이는 실시간 첨삭!<br />
				실시간 첨삭은 학습자가 수업 중에 틀린 문장을 교정 받고,<br />
				잘못된 영어 사용이 습관화되는 것을 방지합니다.<br />
				<br />
				실시간 첨삭을 받는 것만으로도<br />
				수업 내용을 70% 더 오래 기억할 수 있으며,<br />
				첨삭이 기록으로 남아 반복 학습이 가능합니다.
			</p>
			<v-img
				class="mx-auto mb-8"
				max-width="400"
				:src="
					require(`@/assets/img/home/correction${
						userDevice === 'mobile' ? '-min' : ''
					}.png`)
				"
			></v-img>
		</section>
		<section
			class="text-center pb-section"
			:class="{ 'pt-section': userDevice === 'desktop' }"
		>
			<h2 class="text-nls pb-12 text-h4 font-weight-bold">
				3. 부담없고 즐거운<br class="d-block d-sm-none" />
				채팅영어, 텔라
			</h2>
			<p class="text-sm-h6 text-body-1 font-weight-regular text-nls mb-12">
				원어민과 영어로 대화하기… 부담스럽죠!<br />
				텔라의 채팅으로 하는 영어 회화 학습은<br />
				부담감은 줄이고 즐거움은 커집니다.<br />
				<br />
				텔라 이용자들의 높은 출석률과 완주율이 이를 증명합니다.
			</p>
			<v-img
				class="mx-auto mb-8"
				max-width="800"
				:src="
					require(`@/assets/img/services/chart${
						userDevice === 'mobile' ? '-mobile' : ''
					}.png`)
				"
			></v-img>
		</section>
		<section
			class="text-center pb-section"
			:class="{ 'pt-section': userDevice === 'desktop' }"
		>
			<h2 class="text-nls pb-12 text-h4 font-weight-bold">
				4. 학습 성취도 AI 분석
			</h2>
			<p class="text-sm-h6 text-body-1 font-weight-regular text-nls mb-8">
				채팅이기 때문에 객관적으로<br class="d-block d-sm-none" />
				학습 성취도를 분석할 수 있습니다.<br />
				채팅데이터의 AI 분석을 통해<br class="d-block d-sm-none" />
				내 학습 성과를 눈으로 확인해 보세요.
			</p>
			<v-img
				class="mx-auto"
				max-width="900"
				:class="{ 'mt-8': userDevice === 'mobile' }"
				:src="
					require(`@/assets/img/services/monthly-report${
						userDevice === 'mobile' ? '-mobile.png' : '.jpg'
					}`)
				"
			></v-img>
		</section>
		<section
			class="text-center pb-section"
			:class="{ 'pt-section': userDevice === 'desktop' }"
		>
			<h2 class="pb-12 text-h4 font-weight-bold text-nls">
				텔라 학습자들의<br class="d-block d-sm-none" />
				REAL 이용후기
			</h2>
			<div style="width: 50%;margin:0 auto;min-width:300px;">
				<div class="container">
					<iframe
						src="https://player.vimeo.com/video/512785031"
						class="responsive-iframe"
						style="max-width:640px;"
						width="640"
						height="360"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowfullscreen
					></iframe>
				</div>
				<div class="container">
					<iframe
						src="https://player.vimeo.com/video/512807842"
						class="responsive-iframe"
						style="max-width:640px;"
						width="640"
						height="360"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowfullscreen
					></iframe>
				</div>
			</div>
		</section>
		<section
			class="d-flex align-center"
			style="min-height:250px;background-color:#4626ff;"
		>
			<v-img
				style="width:100%;max-width:1200px;"
				:style="userDevice === 'mobile' ? '' : 'min-width:900px;'"
				class="mx-auto white--text d-flex align-center"
				:src="
					require(`@/assets/img/home/are-you-ready${
						userDevice === 'mobile' ? '-mobile' : ''
					}.jpg`)
				"
			>
				<div class="d-flex justify-center align-center">
					<h1
						class="text-nls text-center text-sm-h4 text-rlh text-h5 myungjo px-3"
					>
						이제 텔라를 통해<br />새로운 세상을<br class="d-block d-sm-none" />
						만나 볼 준비가 되셨나요?
					</h1>
				</div>
			</v-img>
		</section>
		<section class="py-section my-12 text-center">
			<h1 class="pb-12 text-h4 font-weight-bold text-nls">
				텔라를 선택한 기업
			</h1>
			<div class="align-center justify-center d-none d-sm-flex">
				<img class="mx-5" src="@/assets/img/home/logos/pubg.jpg" />
				<img class="mx-5" src="@/assets/img/home/logos/ebay.jpg" />
				<img class="mx-5" src="@/assets/img/home/logos/sunday-toz.jpg" />
				<img class="mx-5" src="@/assets/img/home/logos/samsung.jpg" />
				<img class="mx-5" src="@/assets/img/home/logos/mico-group.jpg" />
				<img class="mx-5" src="@/assets/img/home/logos/koica.jpg" />
			</div>
			<img
				style="width:90%;"
				src="@/assets/img/home/b2b-logo-mobile.png"
				class="d-block d-sm-none mx-auto"
				alt=""
			/>
		</section>
		<section class="py-section">
			<v-container class="pt-0" style="max-width:900px;">
				<h2 class="text-center pb-12 text-h4 font-weight-bold text-nls">
					실시간 수업 평점을<br class="d-block d-sm-none" />
					확인하세요!
				</h2>
				<AverageRating class="mb-12 py-5" style="background-color:#fafafa;" />
				<RatingTable
					class="px-4"
					:itemsPerPage="userDevice === 'desktop' ? 10 : 5"
				/>
			</v-container>
		</section>
		<section class="py-section px-3">
			<h1
				class="text-nls text-h4 text-sm-h3 text-center mb-12 font-weight-bold"
			>
				현재 나의 영어 레벨을<br class="d-block d-sm-none" />
				진단해드려요!
			</h1>
			<h3 class="pt-5 mb-5 text-nls text-h6 text-sm-h5 text-center">
				현재 영어 레벨 및 오픽, 토스<br />
				예상 레벨 확인
			</h3>
			<v-card max-width="500" flat outlined class="pa-3 mb-12 mx-auto">
				<div class="d-flex justify-center align-center py-3 px-5">
					<div>
						<img
							src="https://d37egnlosshd9l.cloudfront.net/v2/courses/opic-grey.png"
							alt
							style="width:40px;"
						/>
						<p class="narrow-line-height mb-0 grey--text text--darken-3">IL</p>
					</div>
					<div class="px-5 pt-4">
						<div
							class="grey lighten-2 white--text"
							style="border-radius:50%;width:20px;height:20px;line-height:1em;"
						>
							<i class="fa-xs far fa-equals"></i>
						</div>
					</div>
					<div>
						<img
							src="https://d37egnlosshd9l.cloudfront.net/v2/logo/blue.png"
							alt
							style="width:60px;"
						/>
						<p class="mt-1 strong mb-0 primary--text">Level 4</p>
					</div>
					<div class="px-5 pt-4">
						<div
							class="grey lighten-2 white--text"
							style="border-radius:50%;width:20px;height:20px;line-height:1em;"
						>
							<i class="fa-xs far fa-equals"></i>
						</div>
					</div>
					<div>
						<img
							src="https://d37egnlosshd9l.cloudfront.net/v2/courses/toeicspeaking-grey.png"
							alt
							style="width:40px;"
						/>
						<p class="narrow-line-height mb-0 grey--text text--darken-3">
							Lv 3~4
						</p>
					</div>
				</div>
				<p class="mt-1 grey--text text--darken-1 text-center font-italic small">
					예시
				</p>
			</v-card>
			<h3 class="pt-5 mb-5 text-nls text-h6 text-sm-h5 text-center">
				좋은 영어 구사에 필요한
				<br />3개 요소 상세 분석
			</h3>
			<v-card max-width="500" flat outlined class="pa-3 mb-12 mx-auto">
				<v-row align="center" justify="center" class="text-center">
					<v-col cols="12">
						<div class="px-5" style="max-width:450px;margin:0 auto;">
							<div class="d-flex justify-center mb-5">
								<h2 class="pr-5 font-weight-bold">Total Score</h2>
								<h1 class="font-weight-bold white-space:normal;">
									350
									<small
										class="grey--text text--lighten-1"
										style="font-size:0.6em;"
										>/500</small
									>
								</h1>
							</div>
							<div style="position:relative;" class="pb-8">
								<div
									v-for="n in graphY"
									:key="`graph-${n}`"
									class="d-flex justify-center align-center mt-7"
								>
									<div
										class="text-center grey--text"
										style="line-height:1em;width:30px;vertical-align:middle;"
									>
										<p class="small font-weight-bold">{{ n }}</p>
									</div>
									<div
										style="width:calc(100% - 30px);border-top:1.2px dashed #dadada;vertical-align:middle;"
									></div>
								</div>
								<div
									style="position:absolute;bottom:3px;right:0;width:calc(100% - 30px);"
								>
									<v-row class="text-center">
										<v-col
											cols="4"
											v-for="item in carousels"
											:key="`graph-${item.title}`"
										>
											<div
												class="d-flex align-end justify-center mb-2"
												style="height:270px;"
											>
												<div
													:class="item.color"
													style="width:20px;"
													:style="item.scoreGraphHeight"
												></div>
												<div
													class="grey lighten-1"
													style="width:20px;"
													:style="item.avergHeight"
												></div>
											</div>
											<p class="small text--lighten-1">{{ item.title }}</p>
										</v-col>
									</v-row>
								</div>
							</div>
						</div>
					</v-col>
				</v-row>
				<p class="grey--text text--darken-1 text-center font-italic small">
					예시
				</p>
			</v-card>
			<h3 class="pt-5 mb-5 text-nls text-h6 text-sm-h5 text-center">
				수업 한 달 후
				<br />나의 예상 학습량
			</h3>
			<v-card max-width="500" flat outlined class="pa-3 mb-12 mx-auto">
				<div class="text-center">
					<v-row no-gutters class="white--text grey ligthen-1 py-2">
						<v-col cols="3"></v-col>
						<v-col cols="3">
							<p class="small">
								수업에서
								<br />사용한 단어
							</p>
						</v-col>
						<v-col cols="3">
							<p class="small">
								수업에서
								<br />작성한 문장
							</p>
						</v-col>
						<v-col cols="3">
							<p class="small">
								수업에서
								<br />첨삭 받은 문장
							</p>
						</v-col>
					</v-row>
					<template v-for="i in [8, 12, 20]">
						<v-row no-gutters class="py-3" :key="`oneMonthLater-${i}`">
							<v-col cols="3">
								<p class>{{ i }}회</p>
							</v-col>
							<v-col cols="3">
								<p class>{{ 75 * i }}개</p>
							</v-col>
							<v-col cols="3">
								<p class>{{ 21 * i }}개</p>
							</v-col>
							<v-col cols="3">
								<p class>{{ 8 * i }}개</p>
							</v-col>
						</v-row>
						<v-divider :key="`oneMonthLater-divider-${i}`"></v-divider>
					</template>
				</div>
				<p class="grey--text text--darken-1 text-center mt-2 font-italic small">
					예시
				</p>
			</v-card>
			<h3 class="pt-5 mb-5 text-nls text-h6 text-sm-h5 text-center">
				나의 영어 레벨에 맞는
				<br />프로그램 추천
			</h3>
			<v-card max-width="400" flat class="pa-3 mb-12 mx-auto">
				<v-row class="mx-auto mb-8">
					<v-col
						cols="6"
						v-for="program in programs"
						:key="`program-${program}`"
					>
						<v-card rounded="lg" flat height="200" width="150">
							<v-img
								height="200px"
								class="mx-auto"
								:src="
									`https://image.tella.co.kr/v2/program/cover/mobile/${program}.jpg`
								"
							>
							</v-img>
						</v-card>
					</v-col>
				</v-row>

				<p
					class="italic-font grey--text text--darken-1 text-center mt-1 font-italic small"
				>
					예시
				</p>
			</v-card>
		</section>
		<section style="max-width:500px;" class="mx-auto pb-section">
			<v-card class="pa-3 elevation-0">
				<h3 class="font-weight-bold mb-3">가입 없이 무료로 체험하세요!</h3>
				<v-btn
					x-large
					depressed
					block
					class="rounded-lg"
					color="primary"
					@click="goTrial"
				>
					무료수업 신청하기
				</v-btn>
			</v-card>
		</section>
		<v-footer style="background-color:#474747;">
			<div style="max-width:1024px;" class="px-5 mx-auto">
				<a target="_blank" href="https://tella.co.kr">
					<img class="mt-5" src="@/assets/img/home/white.png" alt="" />
				</a>

				<v-container class="py-3 px-0">
					<div style="padding-top:0px;">
						<v-btn
							color="grey"
							class=""
							icon
							target="_blank"
							href="https://www.facebook.com/TELLAKor"
						>
							<img src="@/assets/img/home/logos/f.jpg" alt="" />
						</v-btn>
						<v-btn
							color="grey"
							class="ml-5"
							icon
							target="_blank"
							href="https://www.instagram.com/tellakor/"
						>
							<img src="@/assets/img/home/logos/i.jpg" alt="" />
						</v-btn>
						<v-btn
							target="_blank"
							href="https://m.blog.naver.com/PostList.nhn?blogId=tellakor"
							color="grey"
							class="ml-6"
							icon
						>
							<img
								style="width:60px;"
								src="@/assets/img/home/logos/b.jpg"
								alt=""
							/>
						</v-btn>
						<v-btn
							color="grey"
							class="ml-6"
							icon
							target="_blank"
							href="https://www.youtube.com/channel/UCXu1Dm9ocPEnu7B_Fic5HjA"
						>
							<v-icon>mdi-youtube</v-icon>
						</v-btn>
					</div>
					<div class="pt-5 white--text text-body-2">
						주식회사 텔라 tella<br />
						서울 강남구 테헤란로79길 6, 502호<br />
						<span class="pr-5">사업자 등록번호 : 114-87-15235</span
						><span class="pr-5"
							>통신판매업신고번호 : 제2019-서울강남-02907호</span
						>원격평생교육시설 : 제 원-594호 (텔라원격평생교육원)<br />
						<span class="pr-5">전화번호 : 070-5118-9565</span>이메일 :
						tella@tella.co.kr<br />
						대표이사: 진유하
					</div>
				</v-container>
			</div>
		</v-footer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/Header'
// import Book from '@/components/Book'
// import Form from '@/components/Form'
import AverageRating from '@/components/review/AverageRating'
import RatingTable from '@/components/review/RatingTable'

export default {
	name: 'home',
	components: {
		Header,
		// Form,
		AverageRating,
		RatingTable,
	},
	data: () => ({
		slide: 0,
		reviews: [
			{
				content:
					'채팅영어는 제가 구사하는 문장이 어떻게 잘못되었는지 바로바로 짚어 줘서 좋아요.',
				reviewer: '박선정 (30대/ 브랜드 마케터)',
			},
			// { code: 'review_sookie', content: '이제 해외 패키지 투어하지 않고 자유여행 다녀요.', reviewer: '이숙희(50대|교사)' },
			{
				content:
					'텔라의 실시간 첨삭을 통해 잘못된 습관을 파악하고 개선하고 있습니다.',
				reviewer: 'Hannah (30대/외국계 영업팀)',
			},
			{
				content:
					'채팅이라 부끄러움이 많아도 시작이 쉽고, 편안한  분위기에서 대화할 수 있어요.',
				reviewer: 'Euna (40대/ 학회 저널 편집자)',
			},
			{
				content:
					'갑자기 야근 등의 일이 생겨도 부담 없이 채팅영어 수업을 할 수 있어서 좋아요.',
				reviewer: 'Jin (20대/외국계 영업팀)',
			},
			{
				content:
					'외국인 직원들과의 콜미팅 중에 배운 표현이 들려 신기했고 저도 표현을 사용할 수 있게 됐어요.',
				reviewer: '박하린 (20대/ IT회사 전략기획팀)',
			},
			{
				content:
					'채팅영어는 마법같은 공부 방법이에요. 이제 외국 바이어들과 농담도 주고 받아요.',
				reviewer: '손경선 (50대/웹디자이너)',
			},
			{
				content: '텔라에서 다양한 영어표현을 익힐 수 있어 답답함이 해소됩니다.',
				reviewer: '전형호 (40대/책임연구원)',
			},
			{
				content:
					'텔라에서 배운 표현으로 메일을 작성해 해외 취재원 3명을 섭외할 수 있게 됐어요.',
				reviewer: 'Genie (20대/언론사 기자)',
			},
		],
		graphY: [10, 8, 6, 4, 2, 0],
		programs: [23, 123, 20, 31],
		carousel: 0,
	}),
	computed: {
		...mapGetters(['windowSize', 'userDevice']),
		category() {
			return this.$route.params.category ? this.$route.params.category : null
		},
		mockupSize() {
			return this.windowSize.x >= 400 ? 375 : this.windowSize.x - 20
		},
		carousels() {
			return [
				{
					title: '문장구성',
					score: 6,
					comment:
						'단순한 문장으로 기초적인 의사전달이 가능합니다(문장당 평균 4-6단어). 복합적인 문장 구성이 가능하도록 여러 형태의 문장을 익혀 보세요.',
					color: 'primary',
					textColor: 'primary--text',
					avergHeight: 'height:153.6px;',
					scoreGraphHeight: `height:${0.6 * 200}px`,
				},
				{
					title: '유창성',
					score: 9,
					comment:
						'대화의 흐름보다는 문장을 만드는 것 자체에 더 집중하시는 것 같아요. 간단한 질문에는 대답할 수 있지만, 약간이라도 변형되면 어려워하시네요. 빠르게 화자의 의도를 파악할 수 있도록 여러가지 상황에서의 대화에 노출되어 보는 것도 좋을 것 같아요.',
					color: 'emerald',
					textColor: 'emerald--text',
					avergHeight: 'height:158.4px;',
					scoreGraphHeight: `height:${0.9 * 200}px`,
				},
				{
					title: '어휘/표현',
					score: 5,
					comment:
						'기초 어휘력은 다져져 있으나, 단어의 다양성이 부족합니다. 이미 알고 있는 단어들을 기반으로 유의어, 반의어를 익혀 보세요.',
					color: 'pink',
					textColor: 'pink--text',
					avergHeight: 'height:168px;',
					scoreGraphHeight: `height:${0.5 * 200}px`,
				},
			]
		},
		anotherPrograms() {
			return [107, 123, 21]
		},
	},
	created() {
		setInterval(() => {
			this.slide++
			if (this.slide >= 8) this.slide = this.slide - 8
		}, 2000)
	},
	methods: {
		goTrial() {
			window.location.href = `https://my.tella.co.kr/trial`
		},
	},
}
</script>

<style scoped>
.container {
	position: relative;
	overflow: hidden;
	width: 100%;
	max-width: 640px;
	margin: 0 auto;
	padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
}
</style>
